import { useSections } from "@/contexts/classified";
export const useRichMedias = () => {
    var _a, _b;
    const sections = useSections();
    const medias = (_a = sections === null || sections === void 0 ? void 0 : sections.enrichedMedia) === null || _a === void 0 ? void 0 : _a.medias;
    return {
        medias: medias || [],
        display: !!((_b = sections === null || sections === void 0 ? void 0 : sections.enrichedMedia) === null || _b === void 0 ? void 0 : _b.medias.length),
    };
};
